import { SpyneTrait } from "spyne";

// local-storage-traits.js
// Example usage in a SpyneTrait style

export class LocalStorageTraits extends SpyneTrait {
  /**
   * The name of the localStorage item we'll store everything under.
   * Adjust if needed.
   */

  constructor(context) {
    let traitPrefix = "localStorage$";
    super(context, traitPrefix);
  }

  static _storageKey = "spyneLocalData";

  /**
   * init method to ensure the localStorage item exists
   */
  static localStorage$Init() {
    const existing = window.localStorage.getItem(this._storageKey);
    if (!existing) {
      // create an empty object
      const blankObj = {};
      window.localStorage.setItem(this._storageKey, JSON.stringify(blankObj));
      //console.log(`[LocalStorageTraits] Initialized ${this._storageKey} in localStorage with {}`,);
    } else {
     //console.log(`[LocalStorageTraits] ${this._storageKey} already exists`);
    }
  }

  /**
   * getProp: read the JSON from _storageKey, return the requested key
   * @param {string} propName - the property inside the stored object
   * @returns {*} The stored value or undefined
   */
  static localStorage$getProp(propName) {
    const raw = window.localStorage.getItem(this._storageKey);
    if (!raw) {
      console.warn(`[LocalStorageTraits] no data for ${this._storageKey}`);
      return undefined;
    }
    let data;
    try {
      data = JSON.parse(raw);
    } catch (err) {
      console.error(
        `[LocalStorageTraits] failed to parse JSON from ${this._storageKey}`,
        err,
      );
      return undefined;
    }
    return data[propName];
  }

  /**
   * setProp: update the stored object with a new key/value
   * @param {string} propName
   * @param {*} value - can be any JSON-serializable data
   */
  static localStorage$setProp(propName, value) {
    const raw = window.localStorage.getItem(this._storageKey);
    let data;
    if (!raw) {
      data = {};
    } else {
      try {
        data = JSON.parse(raw);
      } catch (err) {
        console.error(
          `[LocalStorageTraits] failed to parse JSON from ${this._storageKey}; resetting to {}`,
          err,
        );
        data = {};
      }
    }

    // update the property
    data[propName] = value;

    // write back to localStorage
    const newRaw = JSON.stringify(data);
    window.localStorage.setItem(this._storageKey, newRaw);
   //console.log(`[LocalStorageTraits] setProp ${propName}`, value);
  }


  static localStorage$SetUser(user){
    const time24H =  Date.now() + (24 * 60 * 60 * 1000)
    const time5min = Date.now() +(5 * 60 * 1000);
    const time1min = Date.now() +(60 * 1000);
    user.expiresAt = time24H;


    localStorage.setItem("spyneUser", JSON.stringify(user));
  }

  static localStorage$RemoveUserCache(){
    localStorage.removeItem('spyneUser');
  }

  static localStorage$GetUser(){
     let spyneUser = localStorage.getItem('spyneUser');
     //console.log('spyne user in get user ',{spyneUser})

      if (!spyneUser){
        return null;
      } else{
        try {
          spyneUser = JSON.parse(spyneUser);
        } catch(e){
          return null;
        }
      }


      //console.log("CHECK EXPIRES IN GET USER ",Date.now(), spyneUser.expiresAt, Date.now() > spyneUser.expiresAt)

    if (Date.now() > spyneUser.expiresAt) {
      localStorage.removeItem('spyneUser');
      return null;
    }

    return spyneUser;


  }



  static localStorage$GetCallbackPort(){
    return localStorage.getItem('spyne_callback_port') || '';
  }

  static localStorage$SetCallbackPort(){
    if (location.search.includes('state=') && location.search.includes('code=')) {
      // DO NOT SET IF THIS IS AN AUTH0 REDIRECT;
      return;
    }

      const callbackPort = new URLSearchParams(window.location.search).get('callbackPort');

    if (callbackPort) {
      localStorage.setItem('spyne_callback_port', callbackPort)
      LocalStorageTraits.localStorage$RemoveUserCache();
    }

    //console.log("CALLBACK PORT IS ",callbackPort);

  }

  static localStorage$ClearCallbackPort(){
    localStorage.removeItem('spyne_callback_port')

  }

}
